export const matiesAmer = {
  maties_amer_configurations: `Maties Amer configurations`,
};
